/* ==========================================================================
   AL SULTAN — Boutique layer, Phase 5 (site-wide)
   Stage 2: navigation + predictive search.
   Every link here is taken from the store's real Shopify menu.
   ========================================================================== */
(function () {
  'use strict';

  var SEARCH_SVG =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><circle cx="8.5" cy="8.5" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M13 13l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // The Create Your Perfume builder stays hidden: never echo its link into
  // tiles, search shortcuts or cart suggestions, even if the menu carries it.
  var HIDDEN_LINK = /create-your(-own)?-perfume/i;

  /* Real menu data, read from the rendered drawer */
  function menuData() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return null;
    var shop = [];
    var houses = [];
    drawer.querySelectorAll('.menu-drawer__menu.has-submenu > li > details').forEach(function (details) {
      var title = (details.querySelector(':scope > summary') || {}).textContent || '';
      var list = details.querySelector(':scope > .menu-drawer__submenu .menu-drawer__menu');
      if (!list || !/shop/i.test(title)) return;
      Array.prototype.forEach.call(list.children, function (li) {
        var a = li.querySelector(':scope > a.menu-drawer__menu-item');
        if (a) {
          shop.push({ name: a.textContent.replace(/\s+/g, ' ').trim(), href: a.getAttribute('href') });
          return;
        }
        var sub = li.querySelector(':scope > details');
        if (sub && /brand/i.test((sub.querySelector('summary') || {}).textContent || '')) {
          sub.querySelectorAll('.menu-drawer__submenu a.menu-drawer__menu-item').forEach(function (b) {
            houses.push({ name: b.textContent.replace(/\s+/g, ' ').trim(), href: b.getAttribute('href') });
          });
        }
      });
    });
    function visible(l) {
      return !HIDDEN_LINK.test(l.href || '');
    }
    return { shop: shop.filter(visible), houses: houses.filter(visible) };
  }

  /* ── 1. Boutique menu ──────────────────────────────────────────────── */

  function openSearch() {
    var trigger = document.querySelector('details-modal.header__search summary, .header__icon--search');
    if (trigger) trigger.click();
  }

  function initMenu() {
    var drawer = document.getElementById('menu-drawer');
    var nav = drawer && drawer.querySelector('.menu-drawer__navigation');
    if (!nav || drawer.dataset.alsbMenu) return;
    var data = menuData();
    if (!data) return;
    drawer.dataset.alsbMenu = 'true';

    var reveal = 12;

    // Search entry point
    var search = el('button', 'alsb-menu-search alsb-reveal');
    search.type = 'button';
    search.innerHTML = SEARCH_SVG + '<span>Search fragrances, brands…</span>';
    search.style.setProperty('--i', 1);
    search.addEventListener('click', function () {
      var summary = document.querySelector('header-drawer details[open] > summary');
      if (summary) summary.click();
      setTimeout(openSearch, 380);
    });
    nav.parentNode.insertBefore(search, nav);

    // Shop tiles: Shop's own links, plus Gift Set when it exists in the menu
    var tiles = data.shop.slice();
    var gift = data.houses.filter(function (h) {
      return /gift/i.test(h.name);
    })[0];
    if (gift && !tiles.some(function (t) { return t.href === gift.href; })) tiles.splice(2, 0, gift);

    var anchor = drawer.querySelector('.menu-drawer__utility-links');
    var host = anchor ? anchor.parentNode : nav.parentNode;

    if (tiles.length) {
      var block = el('div', 'alsb-menu-block alsb-reveal');
      block.style.setProperty('--i', reveal++);
      block.appendChild(el('p', 'alsb-menu-block__label', 'Shop the house'));
      var ul = el('ul', 'alsb-tiles');
      tiles.slice(0, 8).forEach(function (t, i) {
        var li = el('li');
        var a = el('a', 'alsb-tile' + (i < 2 ? ' alsb-tile--feature' : ''));
        a.href = t.href;
        a.appendChild(el('span', 'alsb-tile__num', (i + 1 < 10 ? '0' : '') + (i + 1)));
        a.appendChild(el('span', 'alsb-tile__name', t.name.replace(/^For\s+/i, '')));
        a.setAttribute('aria-label', t.name);
        li.appendChild(a);
        ul.appendChild(li);
      });
      block.appendChild(ul);
      host.insertBefore(block, anchor || null);
    }

    var houses = data.houses.filter(function (h) {
      return !/gift/i.test(h.name);
    });
    if (houses.length) {
      var hb = el('div', 'alsb-menu-block alsb-reveal');
      hb.style.setProperty('--i', reveal++);
      hb.appendChild(el('p', 'alsb-menu-block__label', 'Our houses'));
      var row = el('div', 'alsb-houses');
      houses.forEach(function (h) {
        var a = el('a', 'alsb-house', h.name);
        a.href = h.href;
        row.appendChild(a);
      });
      hb.appendChild(row);
      host.insertBefore(hb, anchor || null);
    }
  }

  /* ── 2. Predictive search ──────────────────────────────────────────── */

  function initSearch() {
    var modalSearch = document.querySelector('.search-modal predictive-search');
    if (!modalSearch || modalSearch.dataset.alsbSearch) return;
    modalSearch.dataset.alsbSearch = 'true';
    var input = modalSearch.querySelector('input[type="search"]');
    var data = menuData();
    if (!input || !data) return;

    var links = data.shop.slice();
    var gift = data.houses.filter(function (h) {
      return /gift/i.test(h.name);
    })[0];
    if (gift) links.push(gift);
    if (!links.length) return;

    var start = el('div', 'alsb-search-start');
    start.appendChild(el('p', 'alsb-search-start__label', 'Popular collections'));
    var chips = el('div', 'alsb-search-start__chips');
    links.slice(0, 8).forEach(function (l) {
      var a = el('a', null, l.name);
      a.href = l.href;
      chips.appendChild(a);
    });
    start.appendChild(chips);

    // Child of <predictive-search> (position: relative) so it drops below the
    // field exactly where Shopify's results panel appears.
    modalSearch.appendChild(start);

    function sync() {
      start.hidden = input.value.trim().length > 0;
    }
    input.addEventListener('input', sync);
    sync();

    fitResultsToViewport(modalSearch);
  }

  // Dawn caps the results at innerHeight minus the header, measured once.
  // A phone keyboard covers the page without changing innerHeight, so the
  // results under it never overflow and can't be scrolled to. Size them to
  // the visible viewport instead, and keep that current as the keyboard
  // opens and closes.
  function fitResultsToViewport(search) {
    var vv = window.visualViewport;

    function results() {
      return search.querySelector('.predictive-search');
    }

    function fit() {
      var panel = results();
      if (!panel || !search.hasAttribute('open')) return;
      var visibleBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      var room = Math.floor(visibleBottom - panel.getBoundingClientRect().top - 8);
      if (room > 120) panel.style.maxHeight = room + 'px';
    }

    if (vv) {
      vv.addEventListener('resize', fit);
      vv.addEventListener('scroll', fit);
    }
    window.addEventListener('resize', fit);
    // Dawn writes its own max-height when it opens; correct it right after.
    new MutationObserver(function () {
      requestAnimationFrame(fit);
    }).observe(search, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
  }

  /* ── 3. Cart drawer ────────────────────────────────────────────────── */

  var LOCK_SVG =
    '<svg class="alsb-lock" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><rect x="4" y="9" width="12" height="8.5" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M6.8 9V6.6a3.2 3.2 0 0 1 6.4 0V9" stroke="currentColor" stroke-width="1.5"/></svg>';

  // Dawn re-renders the drawer's contents after every cart change, so these
  // touches are re-applied whenever its markup is replaced.
  function decorateCart(drawer) {
    var heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      var total = 0;
      drawer.querySelectorAll('.cart-item .quantity__input').forEach(function (input) {
        total += parseInt(input.value, 10) || 0;
      });
      var chip = heading.querySelector('.alsb-cart-count');
      if (total > 0) {
        if (!chip) {
          chip = el('span', 'alsb-cart-count');
          heading.appendChild(chip);
        }
        // Only write on change: rewriting text would retrigger the observer
        var label = total + (total === 1 ? ' item' : ' items');
        if (chip.textContent !== label) chip.textContent = label;
      } else if (chip) {
        chip.remove();
      }
    }

    drawer.querySelectorAll('.cart__checkout-button').forEach(function (btn) {
      if (btn.querySelector('.alsb-lock')) return;
      btn.insertAdjacentHTML('afterbegin', LOCK_SVG);
    });

    var empty = drawer.querySelector('.drawer__inner-empty .cart-drawer__empty-content');
    if (empty && !empty.querySelector('.alsb-cart-explore')) {
      var data = menuData();
      if (data && data.shop.length) {
        var box = el('div', 'alsb-cart-explore');
        box.appendChild(el('p', null, 'Explore the house'));
        var row = el('div');
        data.shop.slice(0, 6).forEach(function (l) {
          var a = el('a', null, l.name);
          a.href = l.href;
          row.appendChild(a);
        });
        box.appendChild(row);
        empty.appendChild(box);
      }
    }
  }

  function initCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.alsbCart) return;
    drawer.dataset.alsbCart = 'true';

    decorateCart(drawer);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        decorateCart(drawer);
      }, 0);
    }).observe(drawer, { childList: true, subtree: true });

    // Removal feedback starts immediately; Shopify's update runs as normal.
    document.addEventListener(
      'click',
      function (e) {
        var remove = e.target.closest('cart-remove-button button, cart-remove-button');
        if (!remove) return;
        var line = remove.closest('.cart-item');
        if (line && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) line.classList.add('alsb-removing');
      },
      true
    );
  }

  /* Overlay state on <html> (Phase 7.2): chat widgets hide while search, menu or cart is open.
     Mirrored here so the CSS needs no body:has(), which made every node a tracking script added
     to <body> restyle the whole page. MutationObserver callbacks run before the next frame, so
     the widgets hide in the same frame as before. */
  var overlayObserver = null;

  function syncOverlays() {
    var root = document.documentElement;
    root.classList.toggle('als-ov-search', !!document.querySelector('details-modal.header__search details[open]'));
    root.classList.toggle('als-ov-menu', !!document.querySelector('header-drawer details[open]'));
    root.classList.toggle('als-ov-cart', !!document.querySelector('cart-drawer.active'));
  }

  function watchOverlays() {
    if (!overlayObserver) overlayObserver = new MutationObserver(syncOverlays);
    document.querySelectorAll('details-modal.header__search, header-drawer, cart-drawer').forEach(function (node) {
      if (node.dataset.alsOverlay) return;
      node.dataset.alsOverlay = 'true';
      if (node.tagName === 'CART-DRAWER') {
        overlayObserver.observe(node, { attributes: true, attributeFilter: ['class'] });
      } else {
        overlayObserver.observe(node, { attributes: true, attributeFilter: ['open'], subtree: true });
      }
    });
    syncOverlays();
  }

  function boot() {
    initMenu();
    initSearch();
    initCart();
    watchOverlays();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
